import { render, staticRenderFns } from "./mytrader_doc.vue?vue&type=template&id=3401fb8e&scoped=true"
import script from "./mytrader_doc.vue?vue&type=script&lang=js"
export * from "./mytrader_doc.vue?vue&type=script&lang=js"
import style0 from "./mytrader_doc.vue?vue&type=style&index=0&id=3401fb8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3401fb8e",
  null
  
)

export default component.exports